import { Component, OnInit, Output, EventEmitter, Inject  } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { first } from 'rxjs/operators';
import { AppComponent } from '../../app.component';

import { AuthenticationService } from '../../_services';
// para formulario
import { MatSnackBar} from '@angular/material/snack-bar';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material';
import { MatIconModule} from '@angular/material/icon'; 
import { ShopifyService } from '../../_services'
import { environment } from 'src/environments/environment';

@Component({ 
  selector: 'app-login',
  templateUrl: 'login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  loginFormCorreo: FormControl;
  loginFormPassword: FormControl;
  loading = false;
  submitted = false;
  returnUrl: string;
  error: string;
  success: string;
  currentRole: any;
  bloqueado = false;
  user_token: string;
  loginFormTienda :FormControl;

  restaurarForm: FormGroup;
  el_correo: string;

  //shopify 
  shopi_code: string;
  shopi_shop: string;
  shopi_state: string;
  hay_params = false;
  spinner = false;
  user: any;
  usuario: any;
  user_id: any;

  //Amazon
  amazon_callback_uri: string;
  amazon_state: string;
  selling_partner_id: string;

  @Output() newItemEvent = new EventEmitter<any>();

  constructor(
      private formBuilder: FormBuilder,
      private route: ActivatedRoute,
      private router: Router,
      private authenticationService: AuthenticationService,
      public dialog: MatDialog,
      private snackBar: MatSnackBar,
      private shopifyService: ShopifyService,
  ) {
    
      // redirect to home if already logged in
      if (this.authenticationService.currentUserValue) {
          this.router.navigate(['/']);
      }

      // console.log("los params son "+this.route.snapshot.queryParams['user_token']);
      // console.log(this.route.snapshot);
      this.user_token = this.route.snapshot.queryParams['user_token'];
      
      if(this.user_token){
        this.hay_params = true;
        this.spinner = true;
        // console.log("Aqui entro al login 1")
        this.authenticationService.logout();
        this.authenticationService.loginByToken(this.user_token)
        .pipe(first())
        .subscribe(
          data => {
            // console.log("en login la data es")
            // console.log(data)
            if(data.result == "200"){
              this.router.navigate([this.returnUrl]);
            }else{
              if(data.result == 400){
                this.bloqueado = true;
                this.error = "Usuario bloqueado";
                this.loading = false;
              }else if(data.result == 350){
                this.error = data.status;
                this.loading = false;
              }else{
                // console.log("acceso no autorizado")
                this.error = "Usuario o clave incorrectos";
                this.loading = false;
              }
            }
          },
          error => {
            this.error = error;
            this.loading = false;
        });
      }


      // shopify 
      this.shopi_code = this.route.snapshot.queryParams['code'];
      this.shopi_shop = this.route.snapshot.queryParams['shop'];
      this.shopi_state = this.route.snapshot.queryParams['state'];
      this.authenticationService.currentUser.subscribe(x => this.user = x);
      if(this.user){
        this.user_id = this.user["id"];
      }
      // console.log("El user es ")
      // console.log(this.user)
      // console.log(this.user_id)
      // console.log("el codigo es " + this.shopi_code)
      if( this.shopi_shop != null){
        this.hay_params = true;
        this.spinner = true;
        // this.authenticationService.logout();
        this.shopifyService.pasar_params(this.shopi_code, this.shopi_shop, this.shopi_state, this.user_id)
        .pipe(first())
        .subscribe(
          data => {

            if(data.body["message"] == "redirigir a shopify por autorizacion" && this.user){
              // abrir dialog para aceptar y enviar el data.body[redirect_url shop y usuario]
              var r = confirm("¿Quieres asociar la tienda " + this.shopi_shop + " a la cuenta " + this.user['seller_name'] + "?");
              if (r == true) {
                window.location.href = data.body["redirect_url"]
              }else{
                this.snackBar.open("Cierra sesion e inicia de nuevo en la cuenta deseada.", "OK", {                      
                  duration: 3500,
                });
              }
            }
            if(data.body["message"] != "shopi_auth_existe"){
              window.location.href = data.body["redirect_url"]
            }else{
              this.snackBar.open("Ya hay una cuenta registrada con la tienda " + this.shopi_shop + ", desvincula la tienda en esa cuenta para poder vincularte.", "OK", {                      
                duration: 10000,
              });
            }
          },
          error => {
           // this.error = error;
           // this.loading = false;
           // this.spinner = false;
      });
       
      }else{
        // console.log("no entro en el if ")
        // console.log(this.shopi_code)
        // console.log(this.shopi_shop)
      }


  }

  ngOnInit() {

      this.loginForm = this.formBuilder.group({
          username: ['', Validators.required, Validators.email],
          password: ['', Validators.required]
      });

      this.loginFormCorreo = new FormControl('', [
        Validators.required,
        Validators.email,
      ]);

      this.loginFormPassword = new FormControl('', [
        Validators.required
      ]);

      this.loginFormTienda  = new FormControl('', [
        Validators.required
      ]);
      // get return url from route parameters or default to '/'
      this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';

      // show success message on registration
      if (this.route.snapshot.queryParams['registered']) {
          this.success = 'Registration successful';
      }

      //Get Amazon params
      this.amazon_callback_uri = this.route.snapshot.queryParams['amazon_callback_uri'];
      this.amazon_state = this.route.snapshot.queryParams['amazon_state'];
      this.selling_partner_id = this.route.snapshot.queryParams['selling_partner_id'];
    }

  // convenience getter for easy access to form fields
  get f() { return this.loginForm.controls; }

  onSubmit(){
    if(this.bloqueado){
      location.reload(true);
    }
    
    this.submitted = true;

    // reset alerts on submit
    this.error = null;
    this.success = null;

    // stop here if form is invalid
    // console.log("El email es " + this.loginFormCorreo.value);
    // console.log("El email es " + this.loginFormPassword.value);
    if (this.loginFormCorreo.invalid || this.loginFormPassword.invalid || this.loginFormTienda.invalid) {
      return;
    }

    this.loading = true;
    // console.log(this.f.username.value)
    // console.log(this.f.password.value)
    this.authenticationService.login(this.loginFormCorreo.value, this.loginFormPassword.value, this.loginFormTienda.value)
      .pipe(first())
      .subscribe(
        data => {
          // console.log("en login la data es")
          // console.log(data)
          if(data.result == "200"){
            this.authenticationService.currentUser.subscribe(x => this.user = x);
            if(this.user){
              let idioma = this.user["idioma"] 
              if (idioma == null || idioma == 'null'){
                idioma = 'es';
              }
              localStorage.setItem('idioma', idioma);
              // console.log(this.user["seller_id"]);
              if(this.user["seller_id"] == 1){
                // this.router.navigate("");
                document.location.href = `${environment.apiUrl}/woo_listings/inventario_y_precio`;
              }
            }
            //Validación de conexión con Amazon
            if ( (this.amazon_callback_uri != null) && (this.amazon_state != null) && (this.selling_partner_id != null)) {
              this.router.navigate(
                ['/connect-amazon'],
                {queryParams: {
                  amazon_callback_uri: this.amazon_callback_uri,
                  amazon_state: this.amazon_state,
                  selling_partner_id: this.selling_partner_id
                }}
              );
            }else{
              this.router.navigate([this.returnUrl]);
            }
            
          }else{
            if(data.result == 400){
              this.bloqueado = true;
              this.error = "Usuario bloqueado";
              this.loading = false;
            }else if(data.result == 350){
              this.error = data.status;
              this.loading = false;
            }else{
              // console.log("acceso no autorizado")
              this.error = "Usuario o clave incorrectos";
              this.loading = false;
            }
          }
        },
        error => {
          this.error = error;
          this.loading = false;
      });
  }

  redirectRegistrar(){
    //Validación de conexión con Amazon
    if ( (this.amazon_callback_uri != null) && (this.amazon_state != null) && (this.selling_partner_id != null)) {
      this.router.navigate(
        ['/registro'],
        {queryParams: {
          amazon_callback_uri: this.amazon_callback_uri,
          amazon_state: this.amazon_state,
          selling_partner_id: this.selling_partner_id
        }}
      );
    }else{
      this.router.navigate(['/registro']);
    }
  }

  openDialog() {
    // console.log("Entro a dialog")
    //const dialogRef = this.open(DialogoRestaurar);
   // const dialogRef = this.dialog.open(DialogExampleComponent, {data: {email: 'carlos@marketful.mx'}});
    let correo = this.loginFormCorreo.value;
    // console.log(correo)
    const dialogRef = this.dialog.open(DialogExampleRestaurar ,{width:'450px', height: 'auto', data: {email: correo}});
    
    //dialogRef.updateSize("500px", "800px");

    dialogRef.afterClosed().subscribe(result => {
      // console.log(`Dialog result: ${result}`);
    });
  }
  }

@Component({
  selector: 'dialog-example-restaurar',
  templateUrl: './dialog-example-restaurar.html',
})
export class DialogExampleRestaurar {

  restaurarForm: FormGroup;
  loading = false;
  submitted = false;
  returnUrl: string;
  error: string;
  el_correo: string;
  mensaje_success = false;
  loginFormCorreo: FormControl;
  spinner = false;

  constructor(
    private formBuilder: FormBuilder,
    private authenticationService: AuthenticationService,
    private route: ActivatedRoute,
    private router: Router,
    private snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<DialogExampleRestaurar>,
    @Inject(MAT_DIALOG_DATA) public data: any
    ){
    if(this.data.email){
      this.el_correo = this.data.email;
    }
  }

  ngOnInit(){
    this.restaurarForm = this.formBuilder.group({
      username: ['', Validators.required],
    });


    this.loginFormCorreo = new FormControl('', [
      Validators.required,
      Validators.email,
    ]);

    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
  }

  get f() { return this.restaurarForm.controls; }

  onSubmit(){
    this.submitted = true;
    this.loading = true;
    this.spinner = true;

    if (this.loginFormCorreo.invalid){
      this.loading = false;
      this.spinner = false;
      return;
    }

    // console.log("El correo a restaurar es "+ this.loginFormCorreo.value)
    this.authenticationService.restaurarPassword(this.loginFormCorreo.value)
      .pipe(first())
      .subscribe(
      data => {
        // console.log("en login la data es")
        // console.log(data)
        if(data.result == "200"){
          this.spinner = false;
          this.mensaje_success = true;
          // const snackBarRef = this.snackBar.open("Solicitud enviada", "OK", {duration: 7000,});
          // snackBarRef.afterDismissed().subscribe(info => {
          //   // location.reload(true);
          //   // Para cuando el usuario quite el snackBar manualmente
          //   // if (info.dismissedByAction === true){
          //   //   this.router.navigate([this.returnUrl]);
          //     // location.reload(true);
          //   // }
          // });
        }else{
          // console.log("acceso no autorizado")
          this.error = "El correo "+ this.f.username.value +" no esta registrado en Marketful";
          this.loading = false;
          this.spinner = false;
        }
      },
      error => {
        this.error = error;
        this.loading = false;
        this.spinner = false;
    });
  }
}